import React from "react";
import "../Styles/WhatsAppFloat.css";

function WhatsAppFloat() {
  const phoneNumber = "7569735453";
  const message = "Hello! I would like to inquire about your services.";
  
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="whatsapp-float-container">
      <a 
        href={whatsappLink} 
        target="_blank" 
        rel="noopener noreferrer"
        className="whatsapp-float-button"
        aria-label="Contact us on WhatsApp"
      >
        <span className="whatsapp-text">WhatsApp</span>
      </a>
    </div>
  );
}

export default WhatsAppFloat;
